import { KeyboardEvent } from "react";
import { StatCardProps } from "../../../utils/types";

const StatCard = ({ data }: { data: StatCardProps }) => {
  const {
    IconComponent,
    iconColor,
    value,
    outOf,
    label,
    actionText,
    percentage,
    percentageColor,
    onClick,
  } = data;
  const isClickable = Boolean(onClick);

  const handleCardKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (!onClick) {
      return;
    }
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className={`w-full h-[110px] p-3 rounded-lg border border-border-gray dark:border-border-gray-dk ${
        isClickable
          ? "cursor-pointer hover:border-selected-option-highlight dark:hover:border-selected-option-highlight-dk"
          : ""
      }`}
      onClick={onClick}
      onKeyDown={handleCardKeyDown}
      role={isClickable ? "button" : undefined}
      tabIndex={isClickable ? 0 : undefined}
    >
      <div className="flex flex-col items-start justify-between h-full">
        <div className="w-full flex items-start justify-between">
          {Array.isArray(IconComponent) ? (
            <div className="flex items-center gap-1">
              {IconComponent.map((iconConfig, index) => {
                const IconComponent = iconConfig.icon;
                return (
                  <div
                    key={index}
                    className={`${iconConfig.bgColor} w-6 h-6 rounded-full flex items-center justify-center`}
                  >
                    <IconComponent
                      className={iconConfig.iconColor}
                    />
                  </div>
                );
              })}
            </div>
          ) : (
            <IconComponent className={iconColor || ""} />
          )}
          {actionText && (
            <button className="text-xs text-verba-blue dark:text-verba-blue-dk font-semibold hover:underline">
              {actionText}
            </button>
          )}
        </div>
        <div className="flex flex-col gap-1 w-full">
          <div className="flex items-baseline">
            <span className="text-xl font-medium text-verba-indigo dark:text-verba-indigo-dk">
              {value}
            </span>
            {outOf && (
              <>
                <span className="ml-1 mr-[3px] text-[12px] font-medium text-gray-placeholder dark:text-gray-placeholder-dk">
                  /
                </span>
                <span className="text-sm font-medium text-gray-placeholder dark:text-gray-placeholder-dk">
                  {outOf}
                </span>
              </>
            )}
          </div>
          <div className="flex items-center justify-between">
            <p className="text-xs text-data dark:text-data-dk">{label}</p>
            {percentage && (
              <div
                className={`${percentageColor} px-1.5 py-0.5 rounded flex items-center justify-center text-xxs font-semibold`}
              >
                {percentage}%
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatCard;
